import React, { memo, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Accordion, AccordionDetails, AccordionSummary, Box, Paper, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import Swal from 'sweetalert2';
import Styles from "../Styles/index.module.css";
import { encrypt } from '../../../../utils/cipher';
import { ls } from '../../../../variables';
import { useStateValue } from '../../../../Hooks/stateProvider';
import { useNavigate } from "react-router-dom";
import UploadAction from '../../../CommonLayouts/UploadAction';
import InfoIcon from '@mui/icons-material/Info';
import { alert } from '../../../../utils/sweetAlert';
import { getDate } from '../../../../utils/getDate';

const PreviewModal = memo(({ open, setOpen, finalResult, type, setIsPreviewClicked, setFinalSubmit, setUploadFlag, setGridData, setFormResult, setCompliance, setFilteredRows }) => {
  // const date = new Date();
  const [expandedAccordian, setExpanedAccordion] = useState(null);


  const pmsCode = ls.get("pmsName")
  const originalPMSName = ls.get("originalPMSName")
  const [{ fy_year, quarter, fileName, fileDetails, moduleType }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const email = ls.get("email");
  const userName = ls.get("userName");
  const handleClose = () => {
    setExpanedAccordion(null);
    setOpen(false);
  };


  const handleSubmit = async () => {
    // const utcTime = Date.now();
    // const date = new Date(utcTime).toLocaleString("en-IN", { year: 'numeric', month: '2-digit', day: '2-digit' });
    const date = getDate();
    let payload;
    let previewList = finalResult.map((element) => {
      const { columns, ...rest } = element
      return rest;
    })
    if (type === "cmm") {
      payload = {
        fileType: "CMM",
        requiredDoc: previewList,
        pmsDetails: [originalPMSName, pmsCode],
        email: email,
        userName: userName,
        fy_year: fy_year,
        quarter: quarter,
        date: date,
      }
    }
    setOpen(false)
    dispatch({ type: "SHOW_LOADER" });
    const encryptedFormData = await encrypt(payload)

    const formData = new FormData();
    formData.append("file", fileDetails);
    formData.append("fileName", fileName);
    formData.append("payload", encryptedFormData);

    const encryptedHeaders = await encrypt({
      authtoken: ls.get("authToken"),
      refreshtoken: ls.get("refreshToken")
    })

    axios
      .post('api/pms/previewPageSubmit', formData, {
        headers: {
          headers: encryptedHeaders
        }
      })
      .then((res) => {
        if (res.data) {
          dispatch({ type: "HIDE_LOADER" });
          alert("Thank you!", "You request was successfully submitted", "success")
          setGridData()
          setFilteredRows()
          setUploadFlag(false);
          setIsPreviewClicked(false);
          setFinalSubmit(false);
          if (moduleType === 'CMM') {
            setCompliance([])
            setFormResult([])
          }
          else {
            setFormResult([])
          }
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        setGridData()
        setFilteredRows()
        setUploadFlag(false);
        setFinalSubmit(false);
        setIsPreviewClicked(false);
        if (moduleType === 'CMM') {
          setCompliance([])
          setFormResult([])
        }
        else {
          setFormResult([])
        }
        if (err?.response?.data?.message == "Token not Found") {
          Swal.fire({
            title: "Session Timed Out!!",
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
          })
            .then((result) => {
              if (result.isConfirmed) {
                ls.removeAll();
                navigate("/")
              }
            })
        }
        else if (err?.response?.data?.message == "Stay Signed in") {
          Swal.fire({
            title: "Session Expiration Warning",
            html: `<span style="font-weight: bold;">Your session is about to expire !</span>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#154063",
            cancelButtonColor: "#d33",
            cancelButtonText: "Log out",
            confirmButtonText: "Stay Logged in",
            customClass: {
              confirmButton: `${Styles.btnConfirm} auto-width`
            }
          }).then(async (result) => {
            if (result.isConfirmed) {
              let payload = ls.get("userInfo")
              let encryptedPayload = await encrypt(payload)
              axios
                .post("/api/pms/createToken", {
                  payload: encryptedPayload
                })
                .then((res) => {
                  ls.set("isUserLoggedIn", true);
                  ls.set("authToken", res.data.authToken)
                  ls.set("refreshToken", res.data.refreshToken)
                })
                .catch((error) => {
                  console.log("error: ", error)
                })
            }
            else {
              axios
                .post("/api/pms/logout", {
                  email: ls.get("email")
                })
                .then((res) => {
                  ls.removeAll();
                  navigate("/");
                })
                .catch((error) => {
                  console.log("error: ", error)
                })
            }
          });
        }
        else {
          alert("Submission Failed!!", err?.response?.data?.message || "An error has occured!!", "error")
        }
      })
  }
  const handleAccordionchange = (panel) => (event, isExpanded) => {
    setExpanedAccordion(isExpanded ? panel : null);
  }

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            height: "85%"
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Box
            sx={{
              display: 'flex',
              justifyContent: "center",
              alignContent: "center",
              padding: "10px",
              gap: "2rem"
            }}
          >
            <Paper elevation={3} style={{ width: "25rem", height: "5.5rem", borderRadius: "15px", fontSize: "1.1rem" }}>
              <div style={{ height: "40%", display: "flex", justifyContent: "center", alignItems: "center", background: "#154063", color: "#ffffff" }}>
                PMS Code:
              </div>
              <div style={{ height: "60%", display: "flex", justifyContent: "center", alignItems: "center", color: "black" }}>
                {ls.get("pmsName")}
              </div>
            </Paper>
            <Paper elevation={3} style={{ width: "25rem", height: "5.5rem", borderRadius: "15px", fontSize: "1.1rem" }}>
              <div style={{ height: "40%", display: "flex", justifyContent: "center", alignItems: "center", background: "#154063", color: "#ffffff" }}>
                {type === "cmm" ? "PMS Name" : ""}
              </div>
              <div style={{ height: "60%", display: "flex", justifyContent: "center", alignItems: "center", color: "black" }}>
                {originalPMSName}
              </div>
            </Paper>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ padding: "0.5rem 2.5rem" }} >
          {finalResult.length > 1 ?
            finalResult?.map((element, index) => {
              return (
                <Accordion key={index} expanded={expandedAccordian === index} onChange={handleAccordionchange(index)}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header">
                    <Typography sx={{ color: "#154063", fontSize: "1rem", fontWeight: 600 }}>
                      {element.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {expandedAccordian == index &&
                      <DataGrid
                        getRowHeight={() => 'auto'}
                        rows={element.rows}
                        columns={element.columns}
                        onCellKeyDown={(params, events) => events.stopPropagation()}
                        rowBufferPx={10}
                        sx={{
                          "& .MuiDataGrid-columnHeaderTitleContainer": {
                            justifyContent: "center",
                          },
                          "& .MuiDataGrid-withBorderColor": {
                            borderRight: "none",
                          },
                          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
                          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                            display: "none",
                          },
                          "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
                          "& .MuiDataGrid-topContainer": { width: "fit-content" },
                          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                            py: "15px",
                            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                              outline: "none !important",
                            },
                          },
                          '& .MuiDataGrid-columnHeaders': { width: "fit-content" },
                          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
                          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                            py: "8px",
                          },
                          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                            py: "15px",
                          },
                          "& .MuiDataGrid-row": { width: "fit-content" },
                        }}
                        style={{
                          color: "#154063",
                          width: "100%",
                          height: "50vh",
                          borderWidth: "2px",
                          borderRadius: "10px",
                        }}
                        // getRowHeight={() => "auto"}
                        disableClickEventBubbling
                        rowsPerPageOptions={[2, 5, 10]}
                        disableSelectionOnClick
                        AutoGenerateColumns={false}
                        disableRowCount
                        scrollbarSize={"0"}
                        autoPageSize
                      />}
                  </AccordionDetails>
                </Accordion>
              )
            }) :
            finalResult.map((element, index) => {
              return (
                <DataGrid
                  getRowHeight={() => 'auto'}
                  getRowId={(row) => row[`${type}_id`]}
                  rows={element.rows}
                  columns={element.columns}
                  onCellKeyDown={(params, events) => events.stopPropagation()}
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                      justifyContent: "center",
                    },
                    "& .MuiDataGrid-withBorderColor": {
                      borderRight: "none",
                    },
                    "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                      display: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
                    "& .MuiDataGrid-topContainer": { width: "fit-content" },
                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                      py: "15px",
                      "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                      },
                    },
                    '& .MuiDataGrid-columnHeaders': { width: "fit-content" },
                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                      py: "8px",
                    },
                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                      py: "15px",
                    },
                    "& .MuiDataGrid-row": { width: "fit-content" },
                  }}
                  style={{
                    color: "#154063",
                    width: "100%",
                    height: "100%",
                    borderWidth: "2px",
                    borderRadius: "10px",
                  }}
                  // getRowHeight={() => "auto"}
                  // pageSize={100}
                  disableClickEventBubbling
                  rowsPerPageOptions={[2, 5, 10]}
                  disableSelectionOnClick
                  // showCellVerticalBorder
                  AutoGenerateColumns={false}
                  // disableRowSelectionOnClick
                  // disableColumnMenu
                  disableRowCount
                  // disableClickEventBubbling
                  // hideFooter
                  // disableColumnSelector
                  scrollbarSize={"0"}
                  autoPageSize
                />
              )
            })}
        </DialogContent>
        <DialogActions style={{ display: "flow" }}>
          <div>
            <div style={{ display: "flex", padding: "0px 20px", paddingBottom: "10px", alignItems: "center", gap: "0.3rem" }} >
              <InfoIcon />
              <div>
                "Please find the upload option available to attach additional documents. Upload additional documents in zip format."
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: "1rem" }}>
              <button className={Styles.uploadBtn} onClick={handleClose}>BACK</button>
              <UploadAction />
              <button className={Styles.FileUploadBtn} onClick={handleSubmit}>SUBMIT</button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
})

export default PreviewModal